export const EVENT_ROUTING = {
  events: 'evenements',
  eventsSlug: ':eventId',
  tabSlug: ':tabSlug',
} as const;
